'use client';
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useShowPageBottomUpsellInViewport } from '#pplx/frontend/apps/ask/hooks/upsells-hooks/useShowPageBottomUpsellInViewport.js';
import { BottomUpsellSlotsTemplate } from '#pplx/frontend/apps/ask/upsell-slots/comet-ntp-bottom/internal/BottomUpsellSlotsTemplate.js';
import { usePageBottomCardUpsellSlotPlan } from '#pplx/frontend/apps/ask/upsell-slots/comet-ntp-bottom/internal/usePageBottomCardUpsellSlotPlan.js';
import { usePageBottomFooterUpsellSlotPlan } from '#pplx/frontend/apps/ask/upsell-slots/comet-ntp-bottom/internal/usePageBottomFooterUpsellSlotPlan.js';
import { UPSELL_SLOT_ACCEPTED_LOCATIONS, UPSELL_SLOT_IDS, } from '#pplx/frontend/apps/ask/upsell-slots/UpsellSlotInventory.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import React, { useEffect, useRef } from 'react';
const PageBottomCard = Dynamic(async () => {
    const { PageBottomCard } = await import('#pplx/frontend/apps/ask/upsell-slots/comet-ntp-bottom/internal/PageBottomCard.js');
    return { default: PageBottomCard };
});
const PageBottomFooter = Dynamic(async () => {
    const { PageBottomFooter } = await import('#pplx/frontend/apps/ask/upsell-slots/comet-ntp-bottom/internal/PageBottomFooter.js');
    return { default: PageBottomFooter };
});
export const PageBottomSlot = ({ callsite, inputRef, onVisibilityChange, }) => {
    const { canShowInViewport: canShowFooterInViewport } = useShowPageBottomUpsellInViewport({
        inputRef,
        maxAskInputRatio: 0.45,
    });
    const { canShowInViewport: canShowCardInViewport } = useShowPageBottomUpsellInViewport({
        inputRef,
        maxAskInputRatio: 0.4,
    });
    const productBannerCallsite = callsite;
    const footerPlan = usePageBottomFooterUpsellSlotPlan({
        input: {
            slotId: UPSELL_SLOT_IDS.homepagePageBottom,
            acceptedLocations: UPSELL_SLOT_ACCEPTED_LOCATIONS.homepagePageBottomFooter,
            source: {
                source: 'homepage',
                responseChannel: 'product_banner_information',
                request: {},
            },
            callsite: {
                ...productBannerCallsite,
                surface: {
                    ...productBannerCallsite.surface,
                    canShowInViewport: canShowFooterInViewport,
                },
            },
        },
    });
    const cardPlan = usePageBottomCardUpsellSlotPlan({
        input: {
            slotId: UPSELL_SLOT_IDS.homepagePageBottom,
            acceptedLocations: UPSELL_SLOT_ACCEPTED_LOCATIONS.homepagePageBottomCard,
            source: {
                source: 'homepage',
                responseChannel: 'product_banner_information',
                request: {},
            },
            callsite: {
                ...productBannerCallsite,
                surface: {
                    ...productBannerCallsite.surface,
                    canShowInViewport: canShowCardInViewport,
                },
            },
        },
    });
    const { set } = BottomUpsellSlotsTemplate.useSlotProps();
    const lastReadyRenderRef = useRef(null);
    const isVisible = footerPlan.show || cardPlan.show;
    useEffect(() => {
        onVisibilityChange?.(isVisible);
    }, [isVisible, onVisibilityChange]);
    useEffect(() => () => onVisibilityChange?.(false), [onVisibilityChange]);
    useEffect(() => {
        if (cardPlan.show) {
            lastReadyRenderRef.current = {
                kind: 'card',
                props: cardPlan.render.props,
            };
            return;
        }
        if (footerPlan.show) {
            lastReadyRenderRef.current = {
                kind: 'footer',
                props: footerPlan.render.props,
            };
        }
    }, [cardPlan, footerPlan]);
    const readyRender = cardPlan.show
        ? { kind: 'card', props: cardPlan.render.props }
        : footerPlan.show
            ? { kind: 'footer', props: footerPlan.render.props }
            : lastReadyRenderRef.current;
    const isConcierge = readyRender?.kind === 'card' &&
        readyRender.props.upsellInformation.name === 'computer_enterprise_concierge';
    useEffect(() => {
        set({ bottomCard: { isVisible } });
    }, [isVisible, set]);
    return (_jsxs(_Fragment, { children: [_jsx(BottomUpsellSlotsTemplate.Renderer, {}), readyRender && (_jsx(BottomUpsellSlotsTemplate.Slot, { slot: "bottomCard", children: readyRender.kind === 'card' ? (_jsx(PageBottomCard, { ...readyRender.props, isVisible: isVisible, termsUrl: isConcierge
                        ? 'https://www.perplexity.ai/hub/legal/ai-strategy-consultation-offer'
                        : undefined })) : (_jsx(PageBottomFooter, { ...readyRender.props })) }))] }));
};
//# sourceMappingURL=PageBottomSlot.js.map